export const SANNIDHI = 'sannidhi'
export const SAMYAMA = 'samyama'
export const LBYANTRA = 'lbyantra'
export const BSP = 'bhavaspandana'
export const DARSHAN = 'darshan'
export const ILMSTUDIOS = 'in-the-lap-of-the-master'
export const ILMLODGES = 'lap-of-the-master'
export const ILM = 'ilm'
export const FMF_M = 'full-moon-flirtations-satsang'
export const FMF_FM = 'full-moon-flirtations'



// WEBPACK FOOTER //
// ./src/constants/programConstants.js